import { useEffect } from "react";
import "../App.css";

function AppDownloadPage() {
  useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // Auto-redirect Android users
    if (/android/i.test(userAgent)) {
      window.location.href =
        "https://play.google.com/store/apps/details?id=com.cosmovex.pdftoolkitai"; // 👉 Replace with your actual Play Store link
    }
  }, []);

  return (
    <div className="app">
      <header className="header">
        <div className="logo">
          <div className="icon-gradient">
            <img
              src="/assets/logo.png"
              alt="App Icon"
              width={28}
              height={28}
              style={{ borderRadius: "6px" }}
            />
          </div>
          <div>
            <h1>PDF Editor & AI Tools Suite</h1>
            <p>Smart, Fast, and Powerful</p>
          </div>
        </div>
      </header>

      <main className="main">
        <section className="hero">
          <div className="hero-content">
            <h1>Download PDF Editor & AI Tools Suite</h1>
            <p>
              Transform how you work with PDFs — chat, extract, summarize, and
              automate documents effortlessly using AI. Download now and boost
              your productivity.
            </p>

            <div className="download">
              <div className="download-buttons">
                <a
                  href="https://play.google.com/store/apps/details?id=com.cosmovex.pdftoolkitai"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="primary big-cta"
                >
                  Get App on Play Store
                </a>
              </div>
            </div>
          </div>

          <div className="hero-image">
            <img
              src="/assets/hero-pdf-ai-toolkit.png"
              alt="App Preview"
              loading="lazy"
            />
          </div>
        </section>
      </main>

      <footer className="footer">
        <p>Available for Android. iOS version coming soon.</p>
      </footer>
    </div>
  );
}

export default AppDownloadPage;
